












import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Mual extends Vue {
  @Prop() setMual: string;

  // mual = "";
  // @Watch("mual")
  // changeMuntah(v) {
  //   this.$emit("mual", v);
  // }
  @Watch("setMual")
  change(v) {
    this.$emit("mual", v);
    // this.mual = v;
  }
}
